import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyApplicationsComponent } from './my-application.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MyApplicationRoutingModule } from './my-application.routing.module';
import { AppTypeNoticeModalComponent } from './app-type-notice-modal/app-type-notice-modal.component';
import { PaymentModule } from '../payment/Payment.module';
import { DataGridComponent } from '@app/shared/custom-component/data-grid/data-grid.component';
import { DxButtonModule, DxDataGridModule, DxPopupModule, DxTemplateModule } from 'devextreme-angular';
import { FeeAndPaymentComponent } from './fee-and-payment/fee-and-payment.component';
import { CaseFlowTimelineComponent } from './case-flow-timeline/case-flow-timeline.component';

@NgModule({
  declarations: [MyApplicationsComponent, AppTypeNoticeModalComponent, FeeAndPaymentComponent, CaseFlowTimelineComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule, PaymentModule, DxDataGridModule, DxButtonModule, DxPopupModule, DxTemplateModule,MyApplicationRoutingModule],
  exports: [MyApplicationsComponent, AppTypeNoticeModalComponent]
})
export class MyApplicationsModule {}
